import { AppSelectBox } from 'components';
import useVideos from 'hooks/API/GET/useVideos';
import { Fragment } from 'react';

function VideosDropDown({
  label,
  enableAPI,
  value,
  handleChange,
  fieldErrors = {},
  dependency = {},
}) {
  const { queryParams = {} } = dependency ?? {};
  const { data, isLoading, isError } = useVideos({
    enabled: enableAPI,
    configs: { params: { mode: 'dropdown', ...queryParams } },
  });

  return (
    <AppSelectBox
      labelProps={{ label: label ?? 'Select a video' }}
      selectProps={{
        value,
        onChange: handleChange,
      }}
      fieldErrors={fieldErrors}
    >
      {isLoading ? (
        <option disabled value="">
          Loading...
        </option>
      ) : isError ? (
        <option disabled value="">
          Failed to load list
        </option>
      ) : (
        <Fragment>
          {data?.data?.length > 0 ? (
            <Fragment>
              <option value="">Choose</option>
              {data?.data?.map((option) => {
                return (
                  <option key={option._id} value={option._id}>
                    {option.originalFileName ?? option.name}
                  </option>
                );
              })}
            </Fragment>
          ) : (
            <option value="">No options found</option>
          )}
        </Fragment>
      )}
    </AppSelectBox>
  );
}

VideosDropDown.defaultProps = {
  handleChange: () => {},
};

export default VideosDropDown;
